import { JiraCardVisual } from '../../packages/atlassian/JiraCardVisual';
import { JiraSprintVisual } from '../../packages/atlassian/JiraSprintVisual';
import { BuzzerVisual } from '../../packages/buzzer/BuzzerVisual';
import { ConnectorVisual } from '../../packages/connector/ConnectorVisual';
import { SmartBoxVisual } from '../../packages/controls/SmartBoxVisual';
import { SmartButtonVisual } from '../../packages/controls/SmartButtonVisual';
import { TextboxVisual } from '../../packages/controls/TextboxVisual';
import { TextGeneratorVisual } from '../../packages/controls/TextGeneratorVisual';
import { CounterVisual } from '../../packages/counter/CounterVisual';
import { FrameVisual } from '../../packages/frame/FrameVisual';
import { DropZoneVisual } from '../../packages/hand/DropZoneVisual';
import { JukeboxVisual } from '../../packages/jukebox/JukeboxVisual';
import { SketchVisual } from '../../packages/marker/SketchVisual'; // Added import
import { IndexCardVisual } from '../../packages/paper/IndexCardVisual';
import { StickyVisual } from '../../packages/paper/StickyVisual';
import { TaskCardVisual } from '../../packages/paper/TaskCardVisual';
import { SymbolVisual } from '../../packages/props/SymbolVisual';
import { ReactionIconVisual } from '../../packages/reactions/ReactionIconVisual';
import { SpinnerVisual } from '../../packages/spinner/SpinnerVisual';
import { StopwatchVisual } from '../../packages/stopwatch/StopwatchVisual';
import { TrayVisual } from '../../packages/tray/TrayVisual';
import { VoterVisual } from '../../packages/voter/VoterVisual';
import { ButtonVisual } from './ButtonVisual';
import { CardPackVisual } from './CardPackVisual';
import { CheckboxVisual } from './CheckboxVisual';
import { GraphicVisual } from './GraphicVisual';
import { NativeVideoVisual } from './NativeVideoVisual';
import { RoadmapCardVisual } from './RoadmapCardVisual';
import { RootVisual } from './RootVisual';
import { ShapeVisual } from './ShapeVisual';
import { TextVisual } from './TextVisual';
import { TokenVisual } from './TokenVisual';
import { TopicVisual } from './TopicVisual';
import { ValueCardVisual } from './ValueCardVisual';
import { YouTubeVideoVisual } from './YouTubeVideoVisual';
import { ZoneVisual } from './ZoneVisual';

export const VisualConfiguration: Record<string, any> = {
    Button: ButtonVisual,
    Buzzer: BuzzerVisual,
    CardPack: CardPackVisual,
    Checkbox: CheckboxVisual,
    Connector: ConnectorVisual,
    Counter: CounterVisual,
    DropZone: DropZoneVisual,
    Frame: FrameVisual,
    Graphic: GraphicVisual,
    Hand: RootVisual,
    IndexCard: IndexCardVisual,
    JiraCard: JiraCardVisual,
    JiraSprint: JiraSprintVisual,
    Jukebox: JukeboxVisual,
    NativeVideo: NativeVideoVisual,
    RoadmapCard: RoadmapCardVisual,
    root: RootVisual,
    ReactionIcon: ReactionIconVisual,
    Shape: ShapeVisual,
    Sketch: SketchVisual,
    SmartBox: SmartBoxVisual,
    SmartButton: SmartButtonVisual,
    Spinner: SpinnerVisual,
    Sticky: StickyVisual,
    Stopwatch: StopwatchVisual,
    Symbol: SymbolVisual,
    TaskCard: TaskCardVisual,
    Text: TextVisual,
    Textbox: TextboxVisual,
    TextGenerator: TextGeneratorVisual,
    Token: TokenVisual,
    Topic: TopicVisual,
    Tray: TrayVisual,
    ValueCard: ValueCardVisual,
    Voter: VoterVisual,
    YouTubeVideo: YouTubeVideoVisual,
    Zone: ZoneVisual,
};
